module.exports = __webpack_public_path__ + "static/media/Parasect_gaussian2.9b024bfc.png";